export const navItemBaseClasses =
  'group rounded-control py-1.5 px-2 flex items-center text-[13px] font-medium transition-[background-color,color,transform,box-shadow] duration-150 ease-out active:scale-[0.98]';

export const navItemInactiveClasses =
  'text-neutral-600 hover:bg-neutral-900/[0.04] hover:text-neutral-900 dark:text-white/70 dark:hover:bg-white/[0.08] dark:hover:text-white';

export const navItemIconClasses =
  'h-4 w-4 transition-colors duration-150 ease';

export const navItemIconActiveClasses = 'text-neutral-900 dark:text-white';

export const navItemIconInactiveClasses =
  'text-neutral-400 group-hover:text-neutral-900 dark:text-white/50 dark:group-hover:text-white';

export const navItemActiveClasses =
  'bg-surface text-neutral-900 shadow-xs ring-1 ring-black/[0.05] dark:bg-white/[0.12] dark:text-white dark:ring-white/[0.08] dark:shadow-none';

export const sidebarGlassClasses =
  'rounded-2xl border border-white/60 dark:border-white/[0.1] bg-gradient-to-b from-white/80 to-white/60 dark:from-[rgba(22,32,50,0.78)] dark:to-[rgba(22,32,50,0.62)] backdrop-blur-2xl backdrop-saturate-150 shadow-[0_8px_24px_rgba(var(--shadow-rgb),0.06),inset_0_1px_0_rgba(255,255,255,0.65)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.45),inset_0_1px_0_rgba(255,255,255,0.08)]';
